import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";

import * as Colors from "../Colors";
import { sortData, getLongestTick, formatLabelList } from "./ChartHelper";

import "./Chart.css";

function getTooltip({ active, label, payload }) {
  if (active) {
    return (
      <div className="Tooltip">
        <p className="label">{`${label}: ${payload[0].value}`}</p>
      </div>
    );
  }
}

function getYWidth(longestTickWord, longestTick) {
  if (longestTickWord.length > 15 || longestTick.length >= 45) {
    return 120;
  } else if (longestTickWord.length > 11 || longestTick.length >= 35) {
    return 100;
  } else if (longestTickWord.length > 8 || longestTick.length > 25) {
    return 80;
  } else {
    return 60;
  }
}

function getLongestTickWord(data) {
  return data.reduce((longest, current) => {
    const words =
      current.name.includes(" co-op") ||
      (current.name.includes(" - ") && /([0-9]+)k/.test(current.name))
        ? [current.name]
        : current.name.split(" ");
    const longestWord = words.reduce((long, curr) =>
      curr.length > long.length ? curr : long
    );
    return longestWord.length > longest.length ? longestWord : longest;
  }, "");
}

export default function HorizontalBar({ data, options }) {
  data = data ?? [];
  data = sortData(data, options);
  options = options ?? [];
  const xLabel = options.xLabel ?? "Number of Responses";
  const longestTick = getLongestTick(data, "name");
  const longestTickWord = getLongestTickWord(data);

  const yWidth = options.yWidth ?? getYWidth(longestTickWord, longestTick);
  const yFontSize = options.yFontSize
    ? options.yFontSize
    : longestTickWord.length > 8 || longestTick.length > 30
    ? 12
    : 14;

  const xMax = options.xMax ?? "auto";

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        layout="vertical"
        margin={{
          top: 20,
          right: 20,
          left: 30 + (options.yMargin ?? 0),
          bottom: 20 + (options.marginBottom ?? 0),
        }}
      >
        <Bar dataKey="value" fill={Colors.ORANGE} isAnimationActive={false}>
          <LabelList
            dataKey="value"
            position="right"
            fill={Colors.PURPLE}
            formatter={(value) => formatLabelList(value, xLabel, options)}
          />
        </Bar>
        <XAxis
          type="number"
          interval={0}
          tick={{ fill: Colors.PURPLE }}
          stroke={Colors.PURPLE}
          label={{
            value: xLabel,
            fill: Colors.PURPLE,
            position: "bottom",
            offset: -2,
          }}
          domain={[0, xMax]}
        />
        <YAxis
          type="category"
          dataKey="name"
          tickLine={false}
          tick={{ fill: Colors.PURPLE }}
          stroke={Colors.PURPLE}
          width={yWidth}
          fontSize={yFontSize}
          interval={0}
        />
        {options.showTooltip && (
          <Tooltip
            cursor={{ fill: "transparent" }}
            content={(props) => getTooltip(props)}
          />
        )}
      </BarChart>
    </ResponsiveContainer>
  );
}
